import { Suspense } from 'react';
import { Await, Link, defer, useLoaderData } from 'react-router-dom';
import {
  H1,
  Badge,
  Table,
  TableBody,
  TableData,
  TableHead,
  TableRow,
  TableLoading,
} from 'ui-rollup';
import { Bill } from '../../types/bill';
import styles from './history.module.css';
import { fetchData } from '../../utils/fetchData';

export const loader = () => {
  const histories = fetchData<any>(
    `${process.env.REACT_APP_BACKEND_API}/bills`,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    },
  );

  return defer({ histories });
};

export const History = () => {
  const data = useLoaderData() as { histories: Bill[] };

  return (
    <>
      <div className={styles.historyContainer}>
        <H1>History 📖</H1>
      </div>
      <div className={styles.tableContainer}>
        <Table>
          <TableRow>
            <TableHead>#</TableHead>
            <TableHead>Bill</TableHead>
            <TableHead>Client</TableHead>
            <TableHead>Date</TableHead>
            <TableHead>Total</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
          <TableBody>
            <Suspense fallback={<TableLoading columnCount={7} />}>
              <Await resolve={data.histories}>
                {(histories: Bill[]) =>
                  histories.map((bill, index) => {
                    const date = new Date(bill.dateOfIssue).toLocaleDateString(
                      undefined,
                      {
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric',
                      },
                    );

                    return (
                      <TableRow key={bill.id}>
                        <TableData>{index + 1}</TableData>
                        <TableData>{bill.billId}</TableData>
                        <TableData>{bill.client.name}</TableData>
                        <TableData>{date}</TableData>
                        <TableData>{bill.total}</TableData>
                        <TableData>
                          <Badge
                            variant={bill.isPaid ? 'success' : 'secondary'}
                          >
                            {bill.isPaid ? 'Paid' : 'Pending'}
                          </Badge>
                        </TableData>
                        <TableData>
                          <Link to={bill.id}>View more</Link>
                        </TableData>
                      </TableRow>
                    );
                  })
                }
              </Await>
            </Suspense>
          </TableBody>
        </Table>
      </div>
    </>
  );
};
